import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { api } from '@/lib/api';
import { MapPin } from 'lucide-react';

const Cities = () => {
  const [cities, setCities] = useState([]);
  const [popular, setPopular] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get('/public/cities'),
      api.get('/public/popular-cities')
    ]).then(([c, p]) => {
      setCities(c.data);
      setPopular(p.data);
    });
  }, []);

  const popularMap = Object.fromEntries(popular.map(p => [p.city, p.project_count]));

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0F2C59]" data-testid="cities-title">Explore Cities</h1>
        <p className="text-sm text-slate-500 mt-1">Discover verified projects across Pan-India</p>

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {cities.map(c => (
            <Link
              key={c.name}
              to={`/search?city=${c.name}`}
              className="bg-white rounded-lg border border-slate-200 p-5 hover:border-[#F97316] hover:shadow-md text-center group"
              data-testid={`city-${c.name}`}
            >
              <MapPin size={22} className="mx-auto text-[#0F2C59] group-hover:text-[#F97316] mb-2" />
              <div className="font-bold text-slate-900">{c.name}</div>
              <div className="text-xs text-slate-500 mt-0.5">{c.state}</div>
              {popularMap[c.name] > 0 && (
                <div className="mt-2 text-xs text-[#F97316] font-semibold">{popularMap[c.name]} projects</div>
              )}
              <div className="mt-2 inline-flex items-center gap-1 text-[10px] uppercase font-semibold tracking-wider text-slate-500">
                {c.tier?.replace('_', ' ')}
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Cities;
